import {
  Component,
  ComponentFactoryResolver,
  Injector,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { ModalService } from '@app/core/ui/modal/modal.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit {
  @ViewChild('hostedComponent', { read: ViewContainerRef, static: true })
  dynamicComponentContainer: ViewContainerRef;
  private currentComponent;
  public title: string;
  public cssClass: string;

  constructor(
    private resolver: ComponentFactoryResolver,
    private modalService: ModalService
  ) {
    // Pass moduleRef from a lazy loaded module for entryComponent to works
    if (this.modalService.modalOptions.moduleRef) {
      this.resolver = this.modalService.modalOptions.moduleRef.componentFactoryResolver;
    }

    if (this.modalService.modalOptions.type) {
      this.cssClass = 'modal-' + this.modalService.modalOptions.type;
    }
  }

  ngOnInit() {
    this.title = this.modalService.modalOptions.title;

    this.initHostedComponent();
  }

  /**
   * Init hosted component inside our host modal within hostedComponent ViewChild
   */
  private initHostedComponent(): void {
    const data = {
      component: this.modalService.modalOptions.hostedComponent,
      inputs: {
        datas: this.modalService.modalOptions.datas,
      },
    };

    // Inputs need to be in the following format to be resolved properly
    const inputProviders = Object.keys(data.inputs).map(inputName => ({
      provide: inputName,
      useValue: data.inputs[inputName],
    }));

    // We create an injector out of the data we want to pass down and this components injector
    const injector = Injector.create({
      providers: inputProviders,
      parent: this.dynamicComponentContainer.parentInjector,
    });

    // We create a factory out of the component we want to create
    const factory = this.resolver.resolveComponentFactory(data.component);

    // We create the component using the factory and the injector
    const component = factory.create(injector);

    // We insert the component into the dom container
    this.dynamicComponentContainer.insert(component.hostView);

    // Destroy the previously created component
    if (this.currentComponent) {
      this.currentComponent.destroy();
    }

    this.currentComponent = component;
  }

  public closeModal(): void {
    this.modalService.cancel();
    this.modalService.destroy();
  }
}
